import React from 'react'
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import { formattedNum, toNiceDateYear } from '../../utils'

interface VolumeChartProps {
  chartData: any[]
  setLatestValue: (value: string | number) => void
}

const VolumeChart: React.FC<VolumeChartProps> = ({ chartData, setLatestValue }) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={chartData} margin={{ top: 20, right: 20, bottom: 40, left: 40 }} barCategoryGap="10%">
        <XAxis
          dataKey="date"
          axisLine={false}
          tickLine={false}
          tick={{ fontSize: 12, fill: '#ffffff', opacity: 0.8 }}
          type="category"
          interval="preserveStartEnd"
        />
        <YAxis
          axisLine={false}
          tickLine={false}
          tick={{ fontSize: 12, fill: '#ffffff', opacity: 0.8 }}
          orientation="right"
          tickFormatter={(value) => {
            if (value >= 1000000) return `${(value / 1000000).toFixed(1)}M`
            if (value >= 1000) return `${(value / 1000).toFixed(1)}K`
            return value.toString()
          }}
        />
        <Tooltip
          cursor={{ fill: '#B3B3BE', opacity: 0.1 }}
          formatter={(val) => {
            setLatestValue(formattedNum(val, true))
            return formattedNum(val, true)
          }}
          labelFormatter={(label) => {
            // Find the data point to get the original timestamp
            const dataPoint = chartData?.find((d) => d.date === label)
            return toNiceDateYear(dataPoint?.timestamp || label)
          }}
          contentStyle={{
            padding: '10px 14px',
            borderRadius: 10,
            borderColor: '#B3B3BE',
            color: 'black',
          }}
        />
        <Bar dataKey="dailyVolumeUSD" fill="#B3B3BE" stroke="#B3B3BE" />
      </BarChart>
    </ResponsiveContainer>
  )
}

export default VolumeChart
